<template>
<span>
    <h3>Seja bem vindo(a) {{usuario.nome}}!</h3>
    <dashboard :pendingLinkParams=pendingLinkParams></dashboard>
</span>
</template>
<script>
import SessionStorage from '@/services/session-storage'

export default {
  name: 'HelloWorld',
  data () {
    return {
      pendingLinkParams: '',
      perfil: 'nenhum'
    }
  },
  created () {
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))

    let perfil = SessionStorage.get('tipoPerfil')

    if (perfil) {
      this.perfil = perfil.replace(/['"]+/g, '')
    }

    this.redirectIfNecessary()

    this.generateDashboard()
  },
  computed: {
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    }
  },
  methods: {
    generateDashboard () {

      if (this.perfil === 'P') {
        this.pendingLinkParams = {
          'tutores': { name: 'Validar Usuário - Gestor', query: { situacao: 'PP', tipo: 3 } },
          'beneficiarios': { name: 'Validar Usuário - Gestor', query: { situacao: 'PP', tipo: 5 } },
          'voluntarios': { name: 'Validar Usuário - Gestor', query: { situacao: 'PP', tipo: 4 } }
        }
        return
      }

      if (this.perfil === 'L') {
        this.pendingLinkParams = {
          'beneficiarios': { name: 'Validar Usuário - Tutor', query: { situacao: 'PP', tipo: 5 } },
          'voluntarios': { name: 'Validar Usuário - Tutor', query: { situacao: 'PP', tipo: 4 } }
        }
        return
      }

      this.pendingLinkParams = {
        'gestores': { name: 'Usuários', query: { situacao: 'PP', tipo: 2 } },
        'beneficiarios': { name: 'Usuários', query: { situacao: 'PP', tipo: 5 } },
        'voluntarios': { name: 'Usuários', query: { situacao: 'PP', tipo: 4 } },
        'tutores': { name: 'Usuários', query: { situacao: 'PP', tipo: 3 } }
      }
    },
    redirectIfNecessary () {
      if (this.perfil === 'V') {
        this.$router.push('/principal-voluntario')
      }

      if (this.perfil === 'B') {
        this.$router.push('/principal-beneficiario')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/Home.vue